import React from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import logo from "../assets/img/footer-logo.png";
import ContactForm from "./modal/contact";

function Footer(props) {
  const [showForm, setShowForm] = useState(false);
  const handleCloseForm = () => setShowForm(false);

  const [email, setEmail] = useState("");

  function handleSubmit(e) {
    e.preventDefault();
    if (email === "") {
      alert("Please enter your email address");
    } else {
      setShowForm(true);
    }
  }

  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <a href="/">
                <img src={logo} alt="logo" className="img-fluid mb-4" />
              </a>
              <p>TECHNOLOGY Is Our Top Priority.</p>
            </div>
            <div className="col-md-4">
              <h5>Get In Touch</h5>
              <p>
                Waqar Zaka Center, Garden Rd, Saddar Saddar Town, Karachi,
                Karachi City, Sindh
              </p>
              <p>info@tmp.org.pk</p>
              <p>+92-311-2380334</p>
            </div>
            <div className="col-md-4">
              <h5>Join A Newsletter</h5>
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="form-group mb-4">
                  <label className="mb-2">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter Email Address"
                  />
                </div>
                <Button type="submit" className="btn mb-4">
                  JOIN
                </Button>
              </form>
            </div>
            <Modal
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={showForm}
              onHide={handleCloseForm}
              className="contactModal"
            >
              <div className="closeIcon" onClick={handleCloseForm}>
                <i className="fa-solid fa-xmark" />
              </div>
              <ContactForm handleCloseForm={handleCloseForm} initialEmail={email} />
            </Modal>
          </div>
          <div className="row">
            <div className="coyright">
              <small>Copyright ©️ 2025 Technology Movement Pakistan</small>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
